import React, { FC, Fragment } from 'react';
import {
  BoldButton,
  ItalicButton,
  OrderedListButton,
  UnderlineButton,
  UnorderedListButton,
} from 'draft-js-buttons';

import { IToolbarPlugins, IToolbarPluginRenderProps } from '../types';

interface IProps {
  plugins: IToolbarPlugins;
}

const EditorToolbar: FC<IProps> = ({ plugins }) => {
  const { Toolbar } = plugins.toolbar;
  const { LinkButton } = plugins.link;

  return (
    <Toolbar>
      {(externalProps: IToolbarPluginRenderProps) => (
        <Fragment>
          <BoldButton {...externalProps} />
          <ItalicButton {...externalProps} />
          <UnderlineButton {...externalProps} />
          <UnorderedListButton {...externalProps} />
          <OrderedListButton {...externalProps} />
          <LinkButton {...externalProps} />
        </Fragment>
      )}
    </Toolbar>
  );
};

export default EditorToolbar;
